module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tripsFound":"{count} found","trip":"Trip","placeholder":"Search for Trip","selectedTrip":"Selected Trip: {number}"},"no":{"tripsFound":"{count} treff","trip":"Tur","placeholder":"Søk etter tur","selectedTrip":"Valgt tur: {number}"}}')
  delete Component.options._Ctor
}
